<p>legal-notice works!</p>
